import { planManagementService } from "./plan-management.service";

export class MapSearchService {
  private static instance: MapSearchService;

  // Method to return the singleton instance
  public static getInstance(): MapSearchService {
    if (!MapSearchService.instance) {
      MapSearchService.instance = new MapSearchService();
    }
    return MapSearchService.instance;
  }

  public async searchAddress(query: string): Promise<any[]> {
    const tokenResponse = await planManagementService.getAzureMapsToken();
  
    const response = await fetch(`https://atlas.microsoft.com/search/address/json?api-version=1.0&query=${encodeURIComponent(query)}&language=nl-NL&limit=5&countrySet=NL`,{
      headers: {
        Authorization: `jwt-sas ${tokenResponse.token}`
      }
    });
  
    if (!response.ok) {
      throw new Error("Azure search failed");
    }
  
    const data = await response.json();
    return data.results;
  }
}


// Export an instance of the mapService class
export const mapSearchService = MapSearchService.getInstance();